module.exports = __webpack_public_path__ + "img/03.38252d9b.jpg";